export interface IHeader {
  label: string;
  field: string;
  width: string;
  className: string;
  tooltip: string;
  ariaSort: string;
  minWidth?: string;
}

export const complaintsTableHeadersAdmin: Array<IHeader> = [
  {
    label: 'Complaint No',
    field: 'complaintId',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: 'descending',
    minWidth: '80px', // Add minWidth property for dynamic width
  },
  {
    label: 'Complaint Date',
    field: 'complaintDate',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '120px', // Add minWidth property for dynamic width
  },
  {
    label: 'Address',
    field: 'addressAndLandmark',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '120px', // Add minWidth property for dynamic width
  },
  {
    label: 'Sector',
    field: 'sector',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '50px', // Add minWidth property for dynamic width
  },
  {
    label: 'Sub Sector',
    field: 'subSector',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '50px', // Add minWidth property for dynamic width
  },
  {
    label: 'Description',
    field: 'description',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '300px', // Add minWidth property for dynamic width
  },
  // {
  //   label: 'PMU Status',
  //   field: 'pmuStatus',
  //   width: 'auto',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  //   minWidth: '40px', // Add minWidth property for dynamic width
  // },
  {
    label: 'Assigned To',
    field: 'assignedTo',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '300px', // Add minWidth property for dynamic width
  },
  {
    label: 'Status',
    field: 'complaintStatus',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '60px', // Add minWidth property for dynamic width
  },
  // {
  //   label: 'Action',
  //   field: 'action',
  //   width: '40px',
  //   className: 'sorting_disabled',
  //   tooltip: '',
  //   ariaSort: '',
  // },
];

export const complaintsTableHeadersSCPD: Array<IHeader> = [
  {
    label: 'Complaint No',
    field: 'complaintId',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: 'descending',
    minWidth: '80px', // Add minWidth property for dynamic width
  },
  {
    label: 'Complaint Date',
    field: 'complaintDate',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '120px', // Add minWidth property for dynamic width
  },
  {
    label: 'Address',
    field: 'addressAndLandmark',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '120px', // Add minWidth property for dynamic width
  },
  {
    label: 'Sector',
    field: 'sector',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '50px', // Add minWidth property for dynamic width
  },
  {
    label: 'Sub Sector',
    field: 'subSector',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '50px', // Add minWidth property for dynamic width
  },
  {
    label: 'Description',
    field: 'description',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '300px', // Add minWidth property for dynamic width
  },
  {
    label: 'Assigned To',
    field: 'assignedTo',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '300px', // Add minWidth property for dynamic width
  },
  {
    label: 'Status',
    field: 'complaintStatus',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '60px', // Add minWidth property for dynamic width
  },
  // {
  //   label: 'Action',
  //   field: 'action',
  //   width: '40px',
  //   className: 'sorting_disabled',
  //   tooltip: '',
  //   ariaSort: '',
  // },
];

export const complaintsTableHeaders: Array<IHeader> = [
  {
    label: 'Complaint No',
    field: 'complaintId',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: 'descending',
    minWidth: '80px', // Add minWidth property for dynamic width
  },
  {
    label: 'Complaint Date',
    field: 'complaintDate',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '120px', // Add minWidth property for dynamic width
  },
  {
    label: 'Address',
    field: 'addressAndLandmark',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '120px', // Add minWidth property for dynamic width
  },
  {
    label: 'Sector',
    field: 'sector',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '50px', // Add minWidth property for dynamic width
  },
  {
    label: 'Sub Sector',
    field: 'subSector',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '50px', // Add minWidth property for dynamic width
  },
  {
    label: 'Description',
    field: 'description',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '300px', // Add minWidth property for dynamic width
  },

  {
    label: 'Status',
    field: 'complaintStatus',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '60px', // Add minWidth property for dynamic width
  },
  // {
  //   label: 'Action',
  //   field: 'action',
  //   width: '40px',
  //   className: 'sorting_disabled',
  //   tooltip: '',
  //   ariaSort: '',
  // },
];

export const userMasterHeaders: Array<IHeader> = [
  {
    label: 'Name',
    field: 'name',
    width: '150px',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
    minWidth: '120px', // Add minWidth property for dynamic width
  },
  {
    label: 'User Type',
    field: 'userType',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '50px',
  },
  {
    label: 'Email',
    field: 'email',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '100px',
  },
  {
    label: 'Mobile',
    field: 'phoneNumber',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    // minWidth: '50px',
  },
  {
    label: 'Address',
    field: 'address',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '150px', // Add minWidth property for dynamic width
  },
  {
    label: 'Country',
    field: 'country',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '40px', // Add minWidth property for dynamic width
  },
  {
    label: 'State',
    field: 'state',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '60px', // Add minWidth property for dynamic width
  },
  // {
  //   label: 'DOB',
  //   field: 'dob',
  //   width: 'auto',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  //   minWidth: '30px', // Add minWidth property for dynamic width
  // },
];

export const userStatePending: Array<IHeader> = [
  {
    label: 'Name',
    field: 'name',
    width: '150px',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
    minWidth: '120px', // Add minWidth property for dynamic width
  },
  // {
  //   label: 'User Type',
  //   field: 'userType',
  //   width: 'auto',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  //   minWidth: '50px',
  // },
  {
    label: 'Email',
    field: 'email',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '100px',
  },
  {
    label: 'Mobile',
    field: 'phoneNumber',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    // minWidth: '50px',
  },
  {
    label: 'Address',
    field: 'address',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '150px', // Add minWidth property for dynamic width
  },
  // {
  //   label: 'Country',
  //   field: 'country',
  //   width: 'auto',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  //   minWidth: '40px', // Add minWidth property for dynamic width
  // },
  // {
  //   label: 'State',
  //   field: 'state',
  //   width: 'auto',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  //   minWidth: '60px', // Add minWidth property for dynamic width
  // },
  // {
  //   label: 'Pincode',
  //   field: 'pincode',
  //   width: 'auto',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  //   minWidth: '60px', // Add minWidth property for dynamic width
  // },
  {
    label: 'District',
    field: 'district',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '60px', // Add minWidth property for dynamic width
  },
  // {
  //   label: 'Approval Status',
  //   field: 'isApproved',
  //   width: 'auto',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  //   minWidth: '60px', // Add minWidth property for dynamic width
  // },
  // {
  //   label: 'Rejection Status',
  //   field: 'isRejected',
  //   width: 'auto',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  //   minWidth: '60px', // Add minWidth property for dynamic width
  // },
  // {
  //   label: 'DOB',
  //   field: 'dob',
  //   width: 'auto',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  //   minWidth: '30px', // Add minWidth property for dynamic width
  // },
];
export const userAdminPending: Array<IHeader> = [
  {
    label: 'Name',
    field: 'name',
    width: '150px',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
    minWidth: '120px', // Add minWidth property for dynamic width
  },
  {
    label: 'User Type',
    field: 'userType',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '50px',
  },
  {
    label: 'Email',
    field: 'email',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '100px',
  },
  {
    label: 'Mobile',
    field: 'phoneNumber',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    // minWidth: '50px',
  },
  {
    label: 'Address',
    field: 'address',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '150px', // Add minWidth property for dynamic width
  },
  {
    label: 'Country',
    field: 'country',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '40px', // Add minWidth property for dynamic width
  },
  {
    label: 'State',
    field: 'state',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '60px', // Add minWidth property for dynamic width
  },
  {
    label: 'Pincode',
    field: 'pincode',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '60px', // Add minWidth property for dynamic width
  },
  {
    label: 'District',
    field: 'district',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '60px', // Add minWidth property for dynamic width
  },
  {
    label: 'Approval Status',
    field: 'isApproved',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
    minWidth: '60px', // Add minWidth property for dynamic width
  },
  // {
  //   label: 'Rejection Status',
  //   field: 'isRejected',
  //   width: 'auto',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  //   minWidth: '60px', // Add minWidth property for dynamic width
  // },
  // {
  //   label: 'DOB',
  //   field: 'dob',
  //   width: 'auto',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  //   minWidth: '30px', // Add minWidth property for dynamic width
  // },
];

export const subCategoryTableHeaders: Array<IHeader> = [
  {
    label: 'Sub-Category',
    field: 'subCategory',
    width: 'auto',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
  },
  {
    label: 'Category',
    field: 'category',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  // {
  //   label: 'Action',
  //   field: 'action',
  //   width: '250px',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  // },
];

// For Category Master

export const CategoryTableHeaders: Array<IHeader> = [
  {
    label: 'Category',
    field: 'category',
    width: 'auto',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
  },
  // {
  //   label: 'Action',
  //   field: 'action',
  //   width: '574px',
  //   className: 'sorting',
  //   tooltip: 'activate to sort column ascending',
  //   ariaSort: '',
  // },
];

export const complaintAssigmentTableHeaders: Array<IHeader> = [
  {
    label: 'User Type',
    field: 'userType',
    width: 'auto',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
  },
  {
    label: 'Category',
    field: 'category',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Sub Category',
    field: 'subCategory',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'States',
    field: 'states',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Assign To',
    field: 'assignTo',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Escalation',
    field: 'escalation',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'SLA',
    field: 'sla',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
];

export const FeedbackTableHeader: Array<IHeader> = [
  {
    label: 'Positive Feedback No',
    field: 'feedbackId',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: 'descending',
  },
  {
    label: 'Positive Feedback Date',
    field: 'feedbackDate',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Address',
    field: 'addressAndLandmark',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Sector',
    field: 'sector',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Sub Sector',
    field: 'subSector',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Description',
    field: 'description',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
];

export const GuidelineTableHeaders: Array<IHeader> = [
  {
    label: 'Category',
    field: 'category',
    width: 'auto',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
  },
  {
    label: 'Sub Category',
    field: 'subCategory',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
];

export const LatestUpdateTableHeaders: Array<IHeader> = [
  {
    label: 'Title',
    field: 'title',
    width: '300px',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
  },
  {
    label: 'Description',
    field: 'description',
    width: '500px',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Date',
    field: 'date',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
];
export const CategoryMasterHeader: Array<IHeader> = [
  {
    label: 'Category',
    field: 'category',
    width: 'auto',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
  },
];

export const DepartmentMasterHeader: Array<IHeader> = [
  {
    label: 'Department',
    field: 'department',
    width: 'auto',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
  },
  {
    label: 'User Type',
    field: 'userType',
    width: 'auto',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
  },
];
export const DesignationMasterHeader: Array<IHeader> = [
  {
    label: 'Designation',
    field: 'designation',
    width: 'auto',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
  },
  {
    label: 'Department',
    field: 'department',
    width: 'auto',
    className: 'sorting_asc',
    tooltip: 'activate to sort column descending',
    ariaSort: 'ascending',
  },
];

export const EventHeader: Array<IHeader> = [
  {
    label: 'Title',
    field: 'title',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Description',
    field: 'description',
    width: '500px',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Location',
    field: 'location',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'URL',
    field: 'url',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Start Date',
    field: 'startDate',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'End Date',
    field: 'endDate',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
];

export const ResourceHeader: Array<IHeader> = [
  {
    label: 'Title',
    field: 'title',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'URL',
    field: 'url',
    width: '500px',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
];

export const HelplineHeader: Array<IHeader> = [
  {
    label: 'Name of Helpline',
    field: 'NameOfHelpline',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Number',
    field: 'Number',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Category',
    field: 'Category',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Target Group',
    field: 'TargetGroup',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Geographic Coverage',
    field: 'GeographicCoverage',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
];

export const InformationHeader: Array<IHeader> = [
  {
    label: 'Type',
    field: 'type',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Title',
    field: 'title',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Description',
    field: 'description',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'URL',
    field: 'url',
    width: '500px',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Name',
    field: 'name',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
];

export const OpportunityHeader: Array<IHeader> = [
  {
    label: 'Type',
    field: 'type',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Title',
    field: 'title',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Description',
    field: 'description',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'URL',
    field: 'url',
    width: '500px',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Org',
    field: 'org',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
];

export const UserOpportunitiesHeader: Array<IHeader> = [
  {
    label: 'User Name',
    field: 'userId.name',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'User Email',
    field: 'userId.email',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Type',
    field: 'type',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Title',
    field: 'title',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Description',
    field: 'description',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Organization',
    field: 'org',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Status',
    field: 'status',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Submitted At',
    field: 'submittedAt',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Admin Feedback',
    field: 'adminFeedback',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
];

export const SchemesHeader: Array<IHeader> = [
  {
    label: 'Name',
    field: 'name',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Title',
    field: 'title',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Implementing Agency',
    field: 'implemementingAgency',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Jurisdiction',
    field: 'jurisdiction',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Gender',
    field: 'gender',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Age group',
    field: 'ageGroup',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Disability',
    field: 'disability',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Percentage of disability',
    field: 'percentageOfDisability',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Benefits',
    field: 'benefits',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Income criteria',
    field: 'incomeCriteria',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'URL',
    field: 'applyUrl',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Documents',
    field: 'documents',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
  {
    label: 'Source',
    field: 'source',
    width: 'auto',
    className: 'sorting',
    tooltip: 'activate to sort column ascending',
    ariaSort: '',
  },
];
